<template>
    <CModal
        title="Редактирование услуги"
        :show.sync="modal.visible"
        :footer="false"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="modal.item">
                    <CRow
                        v-if="assistants"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Помощник</CCol>
                        <CCol sm="9">
                            <CSelect
                                class="mb-0"
                                inline
                                :value="modal.item.assistant ? modal.item.assistant.id : null"
                                :options="assistants"
                                placeholder="Выберите помощника..."
                                @update:value="updateAssistant"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="services"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Услуга</CCol>
                        <CCol sm="9">
                            <CSelect
                                class="mb-0"
                                inline
                                :value="modal.item.assistant_service ? modal.item.assistant_service.id : null"
                                :options="services"
                                placeholder="Выберите услугу..."
                                @update:value="updateService"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена услуги</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ +modal.item.assistant_service.price }} р.
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id && options && options.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Варианты</CCol>
                        <template v-for="option in options">
                            <CCol :key="option.id" sm="6">
                                <CInputRadio
                                    class="mb-0"
                                    inline
                                    name="option"
                                    :value="option.id"
                                    :checked="selectedOption === option.id"
                                    @update:checked="updateOptions"
                                />{{ option.title }} - {{ option.price }} р.
                            </CCol>
                        </template>
                    </CRow>
                    <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id && extras && extras.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Дополнительно</CCol>
                        <template v-for="extra in extras">
                            <CCol :key="extra.id" sm="6">
                                <CInputCheckbox
                                    class="mb-0"
                                    inline
                                    :value="extra.id"
                                    :checked="selectedExtras.indexOf(extra.id) >= 0"
                                    @update:checked="updateExtras"
                                />{{ extra.title }} - {{ extra.price }} р.
                            </CCol>
                        </template>
                    </CRow>
                    <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена позиции</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.price"
                                placeholder="Цена позиции"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Количество</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.quantity"
                                placeholder="Количество"
                            />
                        </CCol>
                    </CRow>
                    <!-- <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id"
                        form
                        class="form-group align-items-center">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">Применить скидку заказа</CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="modal.item.applyDiscount"
                                class="pt-1" />
                        </CCol>
                    </CRow>
                    <CRow v-if="modal.item.assistant_service && modal.item.assistant_service.id" class="form-group pl-3 danger">
                        В случае если к заказу применена скидка, к этой позиции она будет применена после обновления заказа.
                    </CRow> -->
                    <CRow
                        v-if="modal.item.assistant_service && modal.item.assistant_service.id && !modal.item.isNewPosition"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Возврат</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value="modal.item.refund_for"
                                :options="refund_for"
                                placeholder="За счет..."
                                @update:value="updateRefund"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model="modal.item.refund_comment"
                                placeholder="Комментарий"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model.number="modal.item.refund_sum"
                                :placeholder="modal.item.refund_sum ? modal.item.refund_sum : modal.item.price * modal.item.quantity"
                            />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!(modal.item.assistant_service && modal.item.assistant_service.id)"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'OrderAHItemEdit',

        props: {
            modal: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                assistants: null,
                services: null,
                options: null,
                extras: null,
                refund_for: [{
                    value: 'МИРСИТИ',
                    label: 'МИРСИТИ'
                },{
                    value: 'Партнера',
                    label: 'Партнера'
                }],
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
            selectedOption() {
                return this.modal.item.options && this.modal.item.options.length ? this.modal.item.options[0].id : null;
            },
            selectedExtras() {
                return this.modal.item.extras.map(i => {
                    return i.id
                });
            },
        },

        watch: {
            visible: async function (val) {
                if(!this.assistants) {
                    try {
                        const { data } = await Vue.axios.get('/assistants');
                        data.sort((a, b) => a.title > b.title ? 1 : -1);
                        this.assistants = data.map(assistant => {
                            return {
                                value: assistant.id,
                                label: assistant.title
                            }
                        });
                    } catch(err) {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    }
                }
                this.services = null;

                if(!this.modal.item.quantity) {
                    this.modal.item.quantity = 1
                }

                if(this.modal.item.assistant && this.modal.item.assistant.id) {
                    await this.getAssistantServices(this.modal.item.assistant.id);
                }

                if(this.modal.item.assistant && this.modal.item.assistant.id && this.modal.item.assistant_service && this.modal.item.assistant_service.id) {
                    await this.getServiceOptions(this.modal.item.assistant.id, this.modal.item.assistant_service.id);
                    await this.getServiceExtras(this.modal.item.assistant.id, this.modal.item.assistant_service.id);
                }
            },
            modal: {
                deep: true,
                handler() {
                    if (this?.modal?.item?.refund_for
                        && !this?.modal?.item?.refund_sum
                        && this?.modal?.item?.refund_sum !== 0
                    && this?.modal?.item?.refund_sum !== '') {
                        this.modal.item.refund_sum = this.modal.item.price * this.modal.item.quantity;
                    }
                }
            }
        },

        mounted() {

        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            async getAssistantServices(assistantId) {
                try {
                    const { data } = await Vue.axios.get(`/assistants/${ assistantId }/services`);
                    data.sort((a, b) => a.title > b.title ? 1 : -1);
                    this.services = data.results.map(service => {
                        return {
                            value: service.id,
                            label: service.title + ' - ' + service.price + ' р.',
                            title: service.title,
                            price: service.price,
                        }
                    });
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getServiceOptions(assistantId, serviceId) {
                try {
                    const { data } = await Vue.axios.get(`/assistants/${ assistantId }/services/${ serviceId }`);
                    this.options = data.options;

                    if(this.options && this.options.length && !this.selectedOption) {
                        this.modal.item.options = [{
                            ...this.options[0]
                        }]
                    }
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getServiceExtras(assistantId, serviceId) {
                try {
                    const { data } = await Vue.axios.get(`/assistants/${ assistantId }/services/${ serviceId }`);
                    this.extras = data.extras;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async updateAssistant(value) {
                for(let i=0; i < this.assistants.length; i++) {
                    if(value === this.assistants[i].value) {
                        this.modal.item = {
                            ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                            ...{
                                id: this.modal.item.id,
                                assistant: {
                                    id: this.assistants[i].value,
                                    title: this.assistants[i].label
                                },
                                isNewPosition: this.modal.item?.isNewPosition
                            }
                        };
                    }
                }
                await this.getAssistantServices(this.modal.item.assistant.id);
            },
            async updateService(value) {
                for(let i=0; i < this.services.length; i++) {
                    if(value === this.services[i].value) {
                        this.modal.item = {
                            ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                            ...{
                                id: this.modal.item.id,
                                assistant: {
                                    id: this.modal.item.assistant.id,
                                    title: this.modal.item.assistant.title,
                                },
                                assistant_service: {
                                    id: this.services[i].value,
                                    title: this.services[i].title,
                                    price: this.services[i].price
                                },
                                assistant_service_id: this.services[i].value,
                                assistant_service_title: this.services[i].title,
                                assistant_service_price: this.services[i].price,
                                isNewPosition: this.modal.item?.isNewPosition
                            }
                        };
                    }
                }
                await this.getServiceOptions(this.modal.item.assistant.id, this.modal.item.assistant_service.id);
                await this.getServiceExtras(this.modal.item.assistant.id, this.modal.item.assistant_service.id);
                this.recalculatePrice();
            },
            updateRefund(refundFor) {
                this.modal.item.refund_for = refundFor;
            },
            updateOptions(checked, obj) {
                for(let i=0; i < this.options.length; i++) {
                    if(+obj.target.value === this.options[i].id) {
                        this.modal.item.options = [{
                            ...this.options[i]
                        }];
                    }
                }
                this.recalculatePrice();
            },
            updateExtras(checked, obj) {
                if(checked) {
                    for(let i=0; i < this.extras.length; i++) {
                        if(+obj.target.value === +this.extras[i].id) {
                            this.modal.item.extras.push(this.extras[i]);
                        }
                    }
                } else {
                    for(let i=0; i < this.modal.item.extras.length; i++) {
                        if(+obj.target.value === +this.modal.item.extras[i].id) {
                            this.modal.item.extras.splice(i, 1);
                        }
                    }
                }
                this.recalculatePrice();
            },
            recalculatePrice() {
                let price = +this.modal.item.assistant_service.price;
                for(let i=0; i < this.modal.item.options.length; i++) {
                    price += +this.modal.item.options[i].price;
                }
                for(let i=0; i < this.modal.item.extras.length; i++) {
                    price += +this.modal.item.extras[i].price;
                }
                this.modal.item.price = price;
            },
        },
    };
</script>

<style scoped>
.danger {
    color: red;
}
</style>
